import {
  Typography,
  TextField,
  DialogContent,
  Divider,
  Grid,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { TenantContext } from "../../common/contexts/TenantContext";
import DragModal from "../../common/components/DragModal";
import { useState, useContext } from "react";
import { UploadFile } from "@mui/icons-material";
import { saveTagListAndTags } from "../../api/APIHelpers";
import { extractApiErrorMessage } from "../../common/helpers/ErrorUtils";

export const ConfigureTagList = ({
  open,
  onClose,
  setTagListInfo,
  tagListInfo,
  setInfoMessages,
  constructNewTagListFromCurrentGrid,
}) => {
  // Name
  // Description
  // Hardware Category
  const [name, setName] = useState(tagListInfo.Name);
  const [desc, setDesc] = useState(tagListInfo.Description);
  const [hwc, setHwc] = useState(tagListInfo.HardwareCategory);
  const [tenantSpecific, setTenantSpecific] = useState(false);
  const [isTagStandard, setIsTagStandard] = useState(false);
  const tenantInfo = useContext(TenantContext);

  const saveNewTagList = async (newTagList) => {
    // Do something here to save grid as a new tag list
    setInfoMessages({
      type: "snackbar",
      severity: "info",
      message: "Tag List has been queued for save.",
      open: true,
    });
    try {
      const [tagListToSave, tagLayersToSave] =
        constructNewTagListFromCurrentGrid(newTagList);
      await saveTagListAndTags(tagListToSave, tagLayersToSave);
      setInfoMessages({
        message: "Tag List saved successfully.",
        severity: "success",
        type: "snackbar",
        open: true,
      });
    } catch (error) {
      setInfoMessages({
        type: "snackbar",
        message: `There was an issue saving the tag list: ${extractApiErrorMessage(error)}`,
        severity: "error",
        open: true,
      });
    }
  };

  return (
    <DragModal
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      titlecomponent={
        <Typography variant='h5' color='primary'>
          Configure New Tag List
        </Typography>
      }>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item>
            <TextField
              value={name || ""}
              onChange={(e) => {
                setName(e.target.value);
              }}
              label='Name'></TextField>
          </Grid>
          <Grid item>
            <TextField
              value={desc || ""}
              onChange={(e) => {
                setDesc(e.target.value);
              }}
              label='Description'></TextField>
          </Grid>
          <Grid item>
            <TextField
              value={hwc || ""}
              onChange={(e) => {
                setHwc(e.target.value);
              }}
              label='Hardware Category'></TextField>
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={tenantSpecific}
                  onChange={(e) => {
                    setTenantSpecific(e.target.checked);
                  }}
                />
              }
              label='Tenant Specific'
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isTagStandard}
                  onChange={(e) => {
                    setIsTagStandard(e.target.checked);
                  }}
                />
              }
              label='Tag Standard'
            />
          </Grid>
          <Grid item>
            <Button
              onClick={async () => {
                let newTagList = {
                  Name: name,
                  Description: desc,
                  HardwareCategory: hwc,
                };
                if (tenantSpecific) {
                  newTagList.TenantId = tenantInfo.currentTenantId;
                }
                if (isTagStandard) {
                  newTagList.isTagStandard = true;
                }
                setTagListInfo(newTagList);
                onClose();
                await saveNewTagList(newTagList);
              }}
              variant='contained'
              startIcon={<UploadFile />}>
              Save
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </DragModal>
  );
};
